import { useEffect, useRef } from "react";

export const AUTO_REFRESH_INTERVAL = 30000;

const useAutoRefresh = (
  callback,
  { intervalMs = AUTO_REFRESH_INTERVAL, enabled = true } = {},
) => {
  const callbackRef = useRef(callback);
  const inFlightRef = useRef(false);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return undefined;

    const tick = async () => {
      if (inFlightRef.current) return;
      if (typeof document !== "undefined" && document.hidden) return;
      inFlightRef.current = true;
      try {
        await callbackRef.current?.();
      } catch (_) {
      } finally {
        inFlightRef.current = false;
      }
    };

    const intervalId = setInterval(tick, intervalMs);
    return () => clearInterval(intervalId);
  }, [enabled, intervalMs]);
};

export default useAutoRefresh;
